<script>
import axios from "axios";

export default class IndiceIpcaRepository {

    getIndicesIpca(token, pageUrl = null, searchQuery = '', searchId = '') {
        let url = pageUrl || `${process.env.VUE_APP_API_URL}indices-ipca`;
        
        const params = new URLSearchParams();
        if (searchId) params.append('id', searchId);
        if (searchQuery) params.append('mes_ano', searchQuery);

        if(params.toString() && !url.includes('?')){
            url += `?${params.toString()}`;
        } else if (params.toString() && url.includes('?')) {
            url += `&${params.toString()}`;
        }

        return axios.get(url, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
    }

    createIndiceIpca(token, data) {
        return axios.post(`${process.env.VUE_APP_API_URL}indices-ipca`, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    }

    updateIndiceIpca(token, id, data) {
        return axios.put(`${process.env.VUE_APP_API_URL}indices-ipca/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    }

    deleteIndiceIpca(token, id) {
        return axios.delete(`${process.env.VUE_APP_API_URL}indices-ipca/${id}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
    }
}
</script>
